// @flow
import { VIDEO } from 'Client/cms/toolkit/constants';
import { VideoLine } from 'Components/lines/video-line/VideoLine';

export const videoDescriptor = {
  name: VIDEO,
  component: VideoLine,
};
